module.exports = __webpack_public_path__ + "img/①香港、日本及澳洲流通药品、保健品、医疗器械：可利用博爱现有门店进行销售地推 提供扫码下单邮寄到家服务（按平均单店销售200元 (1).111f6a94.png";